module.exports = __webpack_public_path__ + "static/media/808RowLabel--CY.f571997a.svg";